export enum UserRole {
  ADMIN = 'admin',
  MANAGER = 'manager',
  STANDARD = 'standard',
  READONLY = 'readonly',
}

export interface User {
  id: number;
  email: string;
  username: string;
  full_name: string | null;
  is_active: boolean;
  is_admin: boolean;
  role: UserRole;
  created_at: string;
  updated_at: string;
}

export interface LoginRequest {
  username: string;
  password: string;
}

export interface LoginResponse {
  access_token: string;
  token_type: string;
}

export interface RegisterRequest {
  email: string;
  username: string;
  password: string;
  full_name?: string;
  role?: UserRole;
}

export interface UserCreateRequest {
  email: string;
  username: string;
  password: string;
  full_name?: string;
  role?: UserRole;
}

export interface UserUpdateRequest {
  email?: string;
  full_name?: string;
  is_active?: boolean;
  is_admin?: boolean;
  role?: UserRole;
}

export interface AuthContextType {
  user: User | null;
  token: string | null;
  login: (username: string, password: string) => Promise<void>;
  logout: () => void;
  isAdmin: boolean;
  isManager: boolean;
  isLoading: boolean;
}
